module.exports = __webpack_public_path__ + "media/images/messagecards/flower-a663322ae7f688f24b92d981a0369d6b.jpg";